import { login, logout, getUserData } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    user: {},
    roles: [],
    // 第一次加载菜单时用到
    loadMenus: false,
    selectUser: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER: (state, user) => {
      state.user = user
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_LOAD_MENUS: (state, loadMenus) => {
      state.loadMenus = loadMenus
    },
    REVISE_USER(state, value) {
      state.selectUser = value
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      commit('SET_ROLES', [])
      const rememberMe = userInfo.rememberMe
      return new Promise((resolve, reject) => {
        // 第一次加载菜单时用到， 具体见 src 目录下的 permission.js
        delete userInfo['rememberMe']
        login(userInfo).then(res => {
          setToken(res.data.token, rememberMe)
          commit('SET_TOKEN', res.data.token)
          // 第一次加载菜单时用到， 具体见 src 目录下的 permission.js
          commit('SET_LOAD_MENUS', true)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetUserData({ commit }) {
      return new Promise((resolve, reject) => {
        getUserData().then(res => {
          if (res.data.level === 2) {
            res.data.permissionList = ['admin', 'user']
          } else if (res.data.menuList !== null) {
            res.data.permissionList = [...res.data.menuList, 'user']
          } else if (res.data.menuList === null) {
            res.data.permissionList = ['user']
          }
          const role = { ...res.data }
          commit('SET_ROLES', role)
          commit('SET_USER', role)
          resolve(role)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    Logout({ commit }, data) {
      return new Promise((resolve) => {
        logout(data).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        }).catch((err) => {
          console.log('logout fail:', err)
          // resolve()
        }).finally(() => {
        })
      })
    },
    ForceOut({ commit }) {
      return new Promise((resolve, reject) => {
        logOut(commit)
        resolve()
      })
    },

    updateLoadMenus({ commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_LOAD_MENUS', false)
      })
    },
    reviseUser({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit('REVISE_USER', data)
      })
    }
  }
}

export const logOut = (commit) => {
  commit('SET_TOKEN', '')
  commit('SET_ROLES', [])
  removeToken()
}

export const setUserInfo = (res, commit) => {
  // 如果没有任何权限，则赋予一个默认的权限，避免请求死循环
  if (res.roles.length === 0) {
    commit('SET_ROLES', ['ROLE_SYSTEM_DEFAULT'])
  } else {
    commit('SET_ROLES', res.roles)
  }
  commit('SET_USER', res.user)
}

export default user
